import { PropertyTypes } from "../../../../enums/PropertyTypes";
import { ISchema, ISchemaProperty } from "../Schema";
import SidePanelWorkstationOuterCube from "../../layout/SidePanel/layouts/SidePanelWorkstationOuterCube";

export const WorkstationOuterCubesSchema: ISchema = {
    displayName: "In Progress",
    GetSidePanelComponent: (data, onViewPage) => <SidePanelWorkstationOuterCube data={data} onViewPage={onViewPage} />,
    props: [
        {
            name: 'id',
            type: PropertyTypes.string,
            key: true
        } as ISchemaProperty,
        {
            name: 'reference',
            displayName: 'Reference',
            descriptor: true,
            type: PropertyTypes.string,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: false,
            requiredInForm: false,
        } as ISchemaProperty,
        {
            name: 'belongsTo',
            displayName: 'Belongs To',
            type: PropertyTypes.string,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: false,
            requiredInForm: false,
        } as ISchemaProperty,
        {
            name: 'outerCubeTypeName',
            displayName: 'Type',
            type: PropertyTypes.string,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: false,
            requiredInForm: false,
        } as ISchemaProperty,
        {
            name: 'percentageFull',
            displayName: 'Percentage Full',
            type: PropertyTypes.percentage,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: false,
            requiredInForm: false,
        } as ISchemaProperty,
    ],

    children: []
}
